function pageFooter() {
  return {
    template: require('./flexi.pageFooter.html')
  };
};
export default pageFooter;


// WEBPACK FOOTER //
// ./src/login/footer/flexi.pageFooter.js